class SectionBackground extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '-45% 0px -45% 0px',
      threshold: [0, 1],
    })

    this.observer.observe(this)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.externalEls.body.element.classList.toggle(
      `lyt-Theme-grey`,
      this.dataset.backgroundStyle === 'grey',
    )
  }
}

if (!customElements.get('section-background')) {
  customElements.define('section-background', SectionBackground)
}
